import { combineReducers } from "@reduxjs/toolkit";
import { loadingBarReducer as loadingBar } from "react-redux-loading-bar";
import authentication from "./authentication";
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer = combineReducers({
  authentication,
  loadingBar,
  //   studyPagination: studyPaginationReducer,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  //   ...entitiesReducers,
});

export default rootReducer;
